import { isAuthenticated } from ".";
import { Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  // CHANGED: Removed redirect to /signin
  // Users are never blocked from browsing — always render child routes.
  // Backend APIs still validate tokens for any write/sensitive operations.
  return <Outlet />;
};

export default ProtectedRoutes;